"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR_MESSAGES = void 0;
exports.ERROR_MESSAGES = {
    FETCH_FAILED: "Failed to fetch.",
    ITUNES_FETCH_FAILED: "Failed to fetch iTunes information for the podcast.",
    ITUNES_NO_FEED_URL: "Unable to retrieve the podcast feed URL from iTunes.",
    ITUNES_NO_PODCASTS_FOUND: "The iTunes search was successful, but no podcasts were found.",
    OPML_INVALID_SOURCE: "Invalid source. Expected a URL or XML string.",
    OPML_NO_FEED_TO_PARSE: "No subscriptions feed available to parse.",
    XML_INVALID_SOURCE: "Invalid source. Expected a URL, iTunes ID, or XML string.",
    XML_NO_FEED_TO_PARSE: "No podcast feed available to parse.",
};
